import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
// import Label from 'src/components/label';
// import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  clipboard: icon('ic_clipboard'),
  paper: icon('ic_paper'),
  money: icon('ic_money'),
  wallet: icon('ic_wallet'),
  deposit: icon('ic_deposit'),
  swimmers: icon('ic_swimmers'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  user_active: icon('ic_user_active'),
  user_id: icon('ic_user_id'),
  user_shield: icon('ic_user_shield'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      // CHATBOT
      // ----------------------------------------------------------------------
      {
        subheader: t(''),
        items: [
          // USER
          {
            title: t('chatbot'),
            path: paths.dashboard.chatbot,
            icon: <Iconify icon="solar:chat-line-bold-duotone" width={24} />,
          },
        ],
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: t('management'),
        items: [
          // USER
          {
            title: t('users'),
            path: paths.dashboard.user.list,
            icon: ICONS.user_active,
            roles: ['admin'],
          },

          // PROFILE
          {
            title: t('profile'),
            path: paths.dashboard.user.profile,
            icon: ICONS.user_id,
            roles: ['admin'],
          },

          // ACCOUNT
          {
            title: t('account'),
            path: paths.dashboard.user.account,
            icon: ICONS.user_shield,
          },
        ],
      },
    ],
    [t]
  );

  return data;
}
